import { downloadBlob } from '@shared/functions/download';

/**
 * @deprecated Use `downloadBlob(data, name, type)` de `@shared/functions/download`.
 * Mantida pela ordem invertida dos argumentos usada nos call sites existentes.
 */
export function downLoadFile(data: any, type: string, name = 'file') {
  downloadBlob(data, name, type);
}
